export default __webpack_public_path__ + "static/media/ICON12.4a7589f3.svg";